/* eslint no-underscore-dangle: ["error", { "allow": ["_fbq"] }] */
import * as React from 'react';

const DEFAULT_META_PIXEL_ID = '1276115421159322';
const META_PIXEL_SCRIPT_SRC = 'https://connect.facebook.net/en_US/fbevents.js';

const getMetaPixelId = () => {
  if (typeof env !== 'undefined' && env.REACT_APP_META_PIXEL_ID) {
    return env.REACT_APP_META_PIXEL_ID;
  }

  if (process.env.REACT_APP_META_PIXEL_ID) {
    return process.env.REACT_APP_META_PIXEL_ID;
  }

  return DEFAULT_META_PIXEL_ID;
};

const appendMetaPixelScript = (pixelId) => {
  const existingScript = document.querySelector(`script[src="${META_PIXEL_SCRIPT_SRC}"]`);

  if (existingScript) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = META_PIXEL_SCRIPT_SRC;
  script.dataset.questriMetaPixelId = pixelId;

  const firstScript = document.getElementsByTagName('script')[0];

  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
    return;
  }

  document.head.appendChild(script);
};

const getOrCreateFbq = () => {
  if (window.fbq) {
    return window.fbq;
  }

  const fbqProxy = (...args) => {
    if (fbqProxy.callMethod) {
      fbqProxy.callMethod(...args);
      return;
    }

    fbqProxy.queue.push(args);
  };

  fbqProxy.push = fbqProxy;
  fbqProxy.loaded = true;
  fbqProxy.version = '2.0';
  fbqProxy.queue = [];

  window.fbq = fbqProxy;

  if (!window._fbq) {
    window._fbq = fbqProxy;
  }

  return fbqProxy;
};

const getMetaPixelState = () => {
  if (!window.questriMetaPixel) {
    window.questriMetaPixel = {
      initializedPixels: {},
      trackedPageViews: {},
    };
  }

  return window.questriMetaPixel;
};

const trackMetaPixelPageView = (pixelId) => {
  const fbq = getOrCreateFbq();
  const metaPixelState = getMetaPixelState();
  const pageViewKey = [
    pixelId,
    window.location.pathname,
    window.location.search,
  ].join(':');

  appendMetaPixelScript(pixelId);

  if (!metaPixelState.initializedPixels[pixelId]) {
    fbq('init', pixelId);
    metaPixelState.initializedPixels[pixelId] = true;
  }

  if (!metaPixelState.trackedPageViews[pageViewKey]) {
    fbq('track', 'PageView');
    metaPixelState.trackedPageViews[pageViewKey] = true;
  }
};

const MetaPixelPageView = () => {
  React.useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    const pixelId = getMetaPixelId();

    if (!pixelId) {
      return;
    }

    trackMetaPixelPageView(pixelId);
  }, []);

  return null;
};

export default MetaPixelPageView;
